import React, { Component } from 'react';
import { connect } from 'react-redux';
import template from '../../templates/Navigator/Navigator.rt';
import navigatorLink from './link';

class Navigator extends Component{
  render = template
}

Navigator.displayName = 'Navigator';

function mapStateToProps(state) {
  const { locationBeforeTransitions } = state.routing;
  return {
    pathname: locationBeforeTransitions
  };
}

const NavigatorContainer = connect(mapStateToProps)(Navigator);
const NavigatorLink = connect(mapStateToProps)(navigatorLink);
export {
  Navigator,
  NavigatorContainer,
  NavigatorLink
};
